/**
 * Renders a recently-viewed product grid from localStorage.
 * On every PDP load, the current product's handle is pushed onto a
 * capped, deduped list (keyed wco_recently_viewed). The element fetches
 * each product's render via the Section Rendering API (?view=card) and
 * inserts the resulting HTML into the grid.
 */
const STORAGE_KEY = 'wco_recently_viewed';
const STORAGE_CAP = 8;

function readList() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeList(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* quota / private mode — silent ignore */
  }
}

function pushHandle(handle) {
  if (!handle) return;
  let list = readList().filter((h) => h !== handle);
  list.unshift(handle);
  if (list.length > STORAGE_CAP) list = list.slice(0, STORAGE_CAP);
  writeList(list);
}

class RecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const currentHandle = this.dataset.currentHandle;
    const max = parseInt(this.dataset.max || '4', 10);

    // Push current handle BEFORE reading, so the rendered list excludes it.
    pushHandle(currentHandle);

    const list = readList()
      .filter((h) => h && h !== currentHandle)
      .slice(0, max);

    if (list.length === 0) {
      this.closest('section')?.remove();
      return;
    }

    const fragments = await Promise.all(
      list.map((handle) =>
        fetch(`/products/${handle}?view=card`, { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.text() : null))
          .catch(() => null)
      )
    );

    const html = fragments.filter(Boolean).join('');
    if (!html) {
      this.closest('section')?.remove();
      return;
    }

    this.innerHTML = html;
  }
}

customElements.define('recently-viewed', RecentlyViewed);
